import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'BlogTag',
})(({ brandColors, spacing, breakpoints, typography, type }) => ({
  tag: {
    textDecoration: 'none',
    '& > span': {
      ...type['10_semibold'],
      borderRadius: typography.pxToRem(16),
      backgroundColor: brandColors.tintsHeroBlue90,
      color: brandColors.black,
      padding: `${typography.pxToRem(4)} ${spacing(-1)}`,
      textTransform: 'uppercase',
      display: 'block',
      width: 'fit-content',
      [breakpoints.up('md')]: {
        ...type['12_semibold'],
        padding: `${spacing(-1)} ${spacing(0)}`,
      },
      '&:hover': {
        backgroundColor: brandColors.chargeBlue,
      },
    },
  },
  link: {
    cursor: 'pointer',
    width: 'fit-content',
  },
}));

export default useStyles;
